// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage'; // Import getStorage

// Your Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyA2Y7h7RKomUuZaGbt7QJg_3AivEkdutVk",
  authDomain: "apptivateai-3deca.firebaseapp.com",
  projectId: "apptivateai-3deca",
  storageBucket: "apptivateai-3deca.appspot.com",
  messagingSenderId: "297473274472",
  appId: "1:297473274472:web:b86fa31c41bfba78f1c1dd",
  measurementId: "G-TWB7FTBHML"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app); // Initialize storage

// Export the initialized services
export { auth, db, storage };
